<template>
  <div class="w-full h-full">
    <input
      v-model="number"
      ref="inputNumber"
      style="font-size: 16px"
      class="h-full border-0 w-full px-2 bg-transparent rounded-lg text-center font-family"
      type="text"
      @keyup="addNumber($event)"
    />
  </div>
</template>

<script>
import mixins from "./mixinNumberCurrency";
export default {
  mixins: [mixins],
};
</script>

<style lang="scss" scoped>
.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
}
</style>
